import { environment } from 'src/environments/environment';

export function resolveImageUrl(rawUrl: string | null | undefined): string {
  if (!rawUrl || typeof rawUrl !== 'string') return 'assets/img/no-image.png';
  const trimmed = rawUrl.trim();
  if (!trimmed) return 'assets/img/no-image.png';

  if (trimmed.startsWith('data:') || trimmed.startsWith('blob:') || trimmed.startsWith('assets/')) {
    return trimmed;
  }

  const apiBase = (environment.apiUrl || 'http://127.0.0.1:3000').replace(/\/+$/, '');

  if (trimmed.includes('/upload/file?key=')) {
    const keyMatch = trimmed.match(/key=([^&]+)/);
    if (keyMatch && keyMatch[1]) {
      return `${apiBase}/upload/file?key=${keyMatch[1]}`;
    }
  }

  if (trimmed.startsWith('/')) {
    return `${apiBase}${trimmed}`;
  }

  if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://')) {
    return `${apiBase}/${trimmed}`;
  }

  if (trimmed.includes('onrender.com/upload') || trimmed.includes('localhost:') || trimmed.includes('127.0.0.1:')) {
    const keyMatch = trimmed.match(/key=([^&]+)/);
    if (keyMatch && keyMatch[1]) {
      return `${apiBase}/upload/file?key=${keyMatch[1]}`;
    }
  }

  return trimmed;
}

export function toRelativeImageUrl(rawUrl: string | null | undefined): string {
  if (!rawUrl || typeof rawUrl !== 'string') return '';
  const trimmed = rawUrl.trim();
  if (!trimmed) return '';

  if (trimmed.startsWith('data:') || trimmed.startsWith('blob:')) {
    return trimmed;
  }

  if (trimmed.includes('/upload/file?key=')) {
    const keyMatch = trimmed.match(/key=([^&]+)/);
    if (keyMatch && keyMatch[1]) {
      return `/upload/file?key=${keyMatch[1]}`;
    }
  }

  if (trimmed.startsWith('/')) {
    return trimmed;
  }

  try {
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
      const urlObj = new URL(trimmed);
      return urlObj.pathname + urlObj.search;
    }
  } catch (err) {}

  return `/${trimmed}`;
}
